import $ from 'jquery'

let _this = {
	phone(rule, value, callback){
          let errors = [], length = value.length, 
            mobile = /^\d{11}$/, tel = /^(0\d{3,4}-?)?\d{7,8}$/g 
          if(!tel.test(value)){
            if(length==11){
                if(!mobile.test(value))
                    errors.push(new Error("手机号码格式错误"))
            }else{
                errors.push(new Error("手机号码格式错误"))
            }
          }

          callback(errors);
    },
    carNum(rule,value,callback){
        let errors=[],carNum=/^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新使]{1}[A-Za-z]{1}[0-9a-zA-Z]{5,6}$/;
        if(!carNum.test(value)){
            if(value.length!=7&&value.length!=8){
                errors.push(new Error("车牌号格式有误"))
            }else{
                errors.push(new Error("车牌号格式有误(不能存在空格)"))
            }  
        }
        callback(errors);
    },
    carPrice(rule,value,callback){
        let errors = [];
        console.log(value);
        if(isNaN(Number(value))){
            errors.push("购车价格必须为数字");
        }
        callback(errors);
    },
    carVin(rule,value,callback){
        let errors=[],carNum=/^\S{17}$/;
        if(!carNum.test(value)){
            if(value.length!=17){
                errors.push(new Error("车架号格式有误"))
            }else{
                errors.push(new Error("车架号格式有误(不能存在空格)"))
            }
        }
        callback(errors);
    },
    idcard(rule, value, callback){
        let errors = [], idcard = /^\d{17}[\d|xX]$/, sum=0,
            checkArr=[7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2],
            fixArr = [1,0,"X",9,8,7,6,5,4,3,2], checked = false
        if(value.length==18 && idcard.test(value)){
            for(var i=0;i<checkArr.length;i++){
                sum += parseInt(value[i])*checkArr[i]
            }
            //console.log([sum,fixArr[sum%fixArr.length]])
            checked = (value.substr(-1).toUpperCase() == fixArr[sum%fixArr.length])
        }
        if(!checked){
            errors.push(new Error("无效的身份证号"))
        }
        callback(errors);
    },
    money(rule, value, callback){
        let errors = [], str = $.isNumeric()? value.toFixed(2) : value, 
            regexp = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([0-9]){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if(!regexp.test(value)){
            errors.push(new Error("金额格式错误"))
            //console.log("aaa")
        }
        callback(errors);
    },
    contract(rule, value, callback){
      let error=[],contract=/^(\w){4,19}$/
      if(!contract.test(value)){
          console.log('falsd')
          error.push(new Error('合同编号格式错误'))
      }
      callback(error)
    },
    isnum(rule, value, callback){
        let error=[],contract=/^[0-9]*[1-9][0-9]*$/
        if(!contract.test(value)){
          console.log('falsd')
          error.push(new Error('请输入数字'))
        }
        callback(error)
    },
    // 正常账号规范
    normalNorm(rule, value, callback){
        let error=[],contract=/^\w{6,}$/
        if(!contract.test(value)){
            console.log('falsd')
            error.push(new Error('请输入至少六位由字母数字下划线组成的账号'))
        }
        callback(error)
      },
    checkAjaxStatus(rule, value, callback){
        let errors = [], f = parseFloat(value)
        if( f <= 0 ){
            errors.push(new Error("成数太小"))
            console.log("bbb")
        } else if( f > 10 ){
            errors.push(new Error("成数太大"))
            console.log("ccc")
        }
        callback(errors);
    }
}

export default _this


// WEBPACK FOOTER //
// ./src/lib/util/validator.js